import { render } from "./TemplateVariable.vue?vue&type=template&id=0e49ba59&scoped=true&lang=pug"
import script from "./TemplateVariable.vue?vue&type=script&lang=js"
export * from "./TemplateVariable.vue?vue&type=script&lang=js"

import "./TemplateVariable.vue?vue&type=style&index=0&id=0e49ba59&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e49ba59"]])

export default __exports__